import { success } from '@/utils/alert'

export default {
  /**
   * Adcionando a lista de favoristos
   * @param {*} professional
   */
  favoriteProfessional (professional) {
    const professionalFavorite = {
      professional_id: professional
    }
    this.$http.post('/v1/patient/favorite-list', professionalFavorite)
    .then(({data}) => {
      success('Médico adicionado a sua lista de favoritos com sucesso.')
    })
    .catch(({data}) => {
      this.errors = data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/favorite/resources/methods.js